// removed by extract-text-webpack-plugin
module.exports = {"background-grey":"#f6f6f6","background-purple":"#eff0f4","white":"#ffffff","medium-grey":"#9f9f9f","black":"#000000","red":"#e40000","wrapper":"_7NBf5vNluyW5hh88LEHEz","preview":"_3Xarb66N_tt412fpXHrjFq","active":"_1lB_Lcfagg_h2mc8w-YF9z","icon":"_1sJ10RjisCz0tNLdyF7X9Q","copyIcon":"_2S7YJsw4pSjrYNuyo0FBg5","appIcon":"_1Pz-hMg3-3k2qRdiUCs4AY","details":"_1Z55dtg4qoBgXU9Zw4F3Qm","name":"xD35LmbisDLyv33fDlX7P","size":"_1OSmG2wz1mMRSjvB2dUbNn"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/foundations/Icons/IconCard/IconCard.css
// module id = 744
// module chunks = 0